<template lang="html">
  <div class="bili">
    <div class="platform headline" :class="{active:show == 0}">
      <!-- banner -->
      <img src="../../assets/image/platform/headline/banner.jpg" alt="" class="banner">
      <!-- content -->
      <div class="content">
        <!-- 你是否处于这样的现状 -->
        <img src="../../assets/image/platform/headline/mod_1.png" alt="" class="mod">

        <!-- 给自己7天时间改变现状，你将获得 -->
        <img src="../../assets/image/platform/headline/mod_2.png" alt="" class="mod">

        <!-- 体验硬六大核心价值 -->
        <img src="../../assets/image/platform/headline/mod_3.png" alt="" class="mod">

        <!-- 体验营大纲 -->
        <img src="../../assets/image/platform/headline/mod_4.png" alt="" class="mod">

        <!-- 豪华专家团队，实战经验倾囊相授 -->
        <img src="../../assets/image/platform/headline/mod_5.png" alt="" class="mod">

        <!-- 豪华专家团队，实战经验倾囊相授 -->
        <img src="../../assets/image/platform/headline/mod_6.png" alt="" class="mod">

        <!-- 体验流程 -->
        <img src="../../assets/image/platform/headline/mod_7.png" alt="" class="mod">

        <!-- 往期精彩活动 -->
        <img src="../../assets/image/platform/headline/mod_8.png" alt="" class="mod">

        <!-- 关于电巢 -->
        <img src="../../assets/image/platform/headline/mod_9.png" alt="" class="mod">
      </div>
    </div>
    <div class="platform bilibili" :class="{active:show == 1}">
      <!-- banner -->
      <img src="../../assets/image/platform/bili/banner.jpg" alt="" class="banner">
      <!-- content -->
      <div class="content">
        <!-- 你是否处于这样的现状 -->
        <img src="../../assets/image/platform/bili/mod_1.png" alt="" class="mod">

        <!-- 给自己7天时间改变现状，你将获得 -->
        <img src="../../assets/image/platform/bili/mod_2.png" alt="" class="mod">

        <!-- 体验硬六大核心价值 -->
        <img src="../../assets/image/platform/bili/mod_3.png" alt="" class="mod">

        <!-- 体验营大纲 -->
        <img src="../../assets/image/platform/bili/mod_4.png" alt="" class="mod">

        <!-- 豪华专家团队，实战经验倾囊相授 -->
        <img src="../../assets/image/platform/bili/mod_6.png" alt="" class="mod">

        <!-- 体验流程 -->
        <img src="../../assets/image/platform/bili/mod_7.png" alt="" class="mod">

        <!-- 往期精彩活动 -->
        <img src="../../assets/image/platform/bili/mod_8.png" alt="" class="mod">

        <!-- 关于电巢 -->
        <img src="../../assets/image/platform/bili/mod_9.png" alt="" class="mod">
      </div>
    </div>
    <div class="platform wx" :class="{active:show == 2}">
      <!-- banner -->
      <img src="../../assets/image/platform/wx/banner.jpg" alt="" class="banner">
      <!-- content -->
      <div class="content">
        <!-- 你是否处于这样的现状 -->
        <img src="../../assets/image/platform/wx/mod_1.png" alt="" class="mod">

        <!-- 给自己7天时间改变现状，你将获得 -->
        <img src="../../assets/image/platform/wx/mod_2.png" alt="" class="mod">

        <!-- 体验硬六大核心价值 -->
        <img src="../../assets/image/platform/wx/mod_3.png" alt="" class="mod">

        <!-- 体验营大纲 -->
        <img src="../../assets/image/platform/wx/mod_4.png" alt="" class="mod">

        <!-- 豪华专家团队，实战经验倾囊相授 -->
        <img src="../../assets/image/platform/wx/mod_5.png" alt="" class="mod">

        <!-- 豪华专家团队，实战经验倾囊相授 -->
        <img src="../../assets/image/platform/wx/mod_6.png" alt="" class="mod">

        <!-- 体验流程 -->
        <img src="../../assets/image/platform/wx/mod_7.png" alt="" class="mod">

        <!-- 往期精彩活动 -->
        <img src="../../assets/image/platform/wx/mod_8.png" alt="" class="mod">

        <!-- 关于电巢 -->
        <img src="../../assets/image/platform/wx/mod_9.png" alt="" class="mod">
      </div>
    </div>

    <div class="btn">
      <div class="btn_left">
        <p class="current_price"><span>￥</span>{{succeed.price}}</p>
        <div class="discounts">
          <p class="btn_text">专属特惠</p>
          <p class="original_cost"><s>￥{{succeed.origin_price}}</s></p>
        </div>
      </div>
      <div class="btn_right" @click="signUp">
        <p>立即报名</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {pagebase} from '@/utils/http.js';
  import utils from '@/utils/utils';
  import WxShare from '@/utils/wxshare';

  // 百度
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?24b8cea1e8cafdb512e2f597cf3fa8df";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();

  // 头条
  (function(r, d, s) {
    r._tt_config = true;
    var _baq = (r._baq = r._baq || []);
    _baq.methods = ["track", "off", "on"];
    _baq.factory = function(method) {
      return function() {
        var args = Array.prototype.slice.call(arguments);
        args.unshift(method);
        _baq.push(args);
        return _baq
      }
    };
    for (var i = 0; i < _baq.methods.length; i++) {
      var key = _baq.methods[i];
      _baq[key] = _baq.factory(key)
    }
    _baq.load = function() {
      var js, fjs = d.getElementsByTagName(s)[0];
      js = d.createElement(s);
      js.src = "https://analytics.oceanengine.com/api/v2/js/sdk";
      fjs.parentNode.insertBefore(js, fjs)
    };
    _baq.load();
    if (_baq.invoked) {
      return
    }
    _baq.invoked = true;
    _baq.track("pageview")
  })(window, document, "script");

  export default {
    data() {
      return {
        activity_id: this.$route.query.activity_id || '',
        succeed: [],
        platform: this.$route.query.platform || '',
        show: 0,
      };
    },
    mounted() {
      this.init();
      this.showStat();
      this.activity();
    },
    methods: {
      init() {
        this.wxshare = new WxShare();
        if (this.platform == 1) {
          this.show = 1
        } else if (this.platform == 2) {
          this.show = 2
        }
      },
      showStat() {
        this.$http({
          url: '/api/showStat',
          method: 'post',
          params: {
            url: window.location.href,
          }
        })
      },
      activity() {
        this.$http({
          url: '/activity/Info',
          method: 'get',
          params: {
            activity_id: this.activity_id,
          },
        }).then(res => {
          if (res.code >= 0) {
            let data = res.data;
            this.succeed = data;
            document.title = data.title;
            
            this.wxshare.share({
              title: this.succeed.title,
              desc: this.succeed.summary,
              link: window.location.href,
              imgUrl: this.succeed.cover,
            })
          }
        })
      },
      signUp() {
        let succeedUrl = encodeURIComponent(pagebase + '/#/paySucceed?activity_id=' + this.activity_id);
        let project = 'common'
        if (this.platform == 1) {
          project = encodeURIComponent('common?activity_id=200&platform=1')
        } else if (this.platform == 2) {
          project = encodeURIComponent('common?activity_id=200&platform=2')
        }
        if (utils.browserChecker.isWx()) {
          let channel = this.$route.query.channel || '';
          let open = encodeURIComponent(pagebase + '/#/payment?activity_id=' + this.activity_id + '&project=' + project + '&channel=' + channel + '&succeed_url=' + succeedUrl);
          let url = 'http://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
          window.location.href = url;
        } else {
          this.$router.push({
            path: '/payment',
            query: {
              activity_id: this.activity_id,
              channel: this.$route.query.channel || '',
              project: project,
              track_id: this.$route.query.track_id || '',
              succeed_url: succeedUrl,
            }
          })
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .bili {
    background-color: #5055CA;
    padding-bottom: 8rem;
  }

  .platform {
    display: none;
  }

  .active {
    display: block;
  }

  .banner {
    width: 100%;
  }

  .content {
    box-sizing: border-box;
    padding: 0 1.5rem;
  }

  .mod {
    margin-top: 2rem;
    width: 100%;
  }

  .btn {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 8rem;
    width: 100%;
    background-color: #FFEEC0;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-between;
    padding: 0 .8rem;
  }

  .btn_left {}

  .current_price {
    font-size: 3.4rem;
    color: #F40000;
    font-weight: bolder;
  }

  .current_price span {
    font-size: 2rem;
  }

  .discounts {
    margin-left: .4rem;
    display: flex;
    align-items: center;
  }

  .btn_text {
    height: 1.8rem;
    line-height: 1.8rem;
    box-sizing: border-box;
    font-size: 1rem;
    background-color: #FF6200;
    color: #FFFFFF;
    padding: 0 .8rem;
    border-radius: 1rem;
  }

  .original_cost {
    font-size: 1.6rem;
    color: #565555;
  }

  .btn_right {
    width: 12.5rem;
    height: 4.4rem;
    line-height: 4.4rem;
    text-align: center;
    box-sizing: border-box;
    background-color: #F40000;
    font-size: 1.6rem;
    border-radius: 2.2rem;
    color: #F9D346;
  }

  .btn_right span {
    color: #FFFFFF;
  }

  @media (min-width: 751px) {
    .btn {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }
  }
</style>
